interface WeatherSummaryTimeHeaderProps {
  time: Date;
  showDayLabel: boolean;
  formatTime: (date: Date) => string;
  formatDate: (date: Date) => string;
}

export function WeatherSummaryTimeHeader({
  time,
  showDayLabel,
  formatTime,
  formatDate,
}: WeatherSummaryTimeHeaderProps) {
  return (
    <div className="h-10 w-20 border-b border-r border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900 flex flex-col items-center justify-center px-1">
      {showDayLabel ? (
        <>
          <div className="text-xs font-bold text-pink-600 dark:text-pink-400 leading-tight">
            {formatDate(time)}
          </div>
          <div className="text-xs text-gray-600 dark:text-gray-400 leading-tight">
            {formatTime(time)}
          </div>
        </>
      ) : (
        <div className="text-xs font-semibold text-gray-900 dark:text-gray-100">
          {formatTime(time)}
        </div>
      )}
    </div>
  );
}
